import { render, staticRenderFns } from "./supplierUpdate.vue?vue&type=template&id=ddcee780&"
import script from "./supplierUpdate.vue?vue&type=script&lang=js&"
export * from "./supplierUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports